import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import type { FarmHierarchyInfo } from 'utils/organisationContext';
import type { TFunction } from 'types';

type FarmHierarchyContextProps = {
  hierarchy: FarmHierarchyInfo | null;
  farmRoleName?: string;
  compact?: boolean;
  /** When true, hide contextual lines (picker already shows farm). */
  rolesOnly?: boolean;
};

export function FarmHierarchyContext({
  hierarchy,
  compact = false,
  rolesOnly = false,
}: FarmHierarchyContextProps) {
  const { t }: TFunction = useTranslation();

  if (rolesOnly || !hierarchy?.companyName) {
    return null;
  }

  return (
    <Typography.Text style={{ fontSize: compact ? 13 : 14, color: '#475467', marginTop: compact ? 8 : 12 }}>
      <strong>{t('ContextCompany')}:</strong> {hierarchy.companyName}
    </Typography.Text>
  );
}
